export default "__VITE_ASSET__CyIm0dIH__"